import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import { useIntl } from "react-intl";
import { AccountTabTiles } from "@components/molecules";
import * as S from "./styles";
export var AccountTab = function AccountTab() {
  var intl = useIntl();
  return React.createElement(S.Wrapper, null, React.createElement(S.PageHeader, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Personal details",
    "id": "@next.pages.AccountTab.AccountTab.3253048083"
  }, "id", "@next.pages.AccountTab.AccountTab.3253048083"))), React.createElement(AccountTabTiles, null));
};